/* global Sys, Core */
Sys.ns("Core.Slots");

/**
 * The Reality Check module for slots.
 *
 * The module handling the reality check feature.
 *
 * @class Core.Slots.RealityCheck
 * @extends Core.RealityCheck
 */
Core.Slots.RealityCheck = {
    CONTROL_STATE: "stopped",

    constructor: function() {
        Core.Slots.RealityCheck.superclass.constructor.apply(this, arguments);
    }
};

Core.Slots.RealityCheck = Sys.extend(Core.RealityCheck, Core.Slots.RealityCheck, "Core.Slots.RealityCheck");
